import { render } from "./StyleGuide.vue?vue&type=template&id=e82b89e6&scoped=true&lang=pug"
import script from "./StyleGuide.vue?vue&type=script&lang=js"
export * from "./StyleGuide.vue?vue&type=script&lang=js"

import "./StyleGuide.vue?vue&type=style&index=0&id=e82b89e6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82b89e6"]])

export default __exports__